import { Directive, Input, ElementRef, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import * as d3 from 'd3';

@Directive({
  selector: '[ctlBarChart]'
})

export class BarChartDirective implements OnChanges, AfterViewInit {

  colors = ['#0c9b5b', '#3fce8e', '#767676'];
  width = 886;
  height = 330;
  margin = 50;
  duration = 5;

  lineOpacity = '0.25';
  lineOpacityHover = '0.85';
  otherLinesOpacityHover = '0.1';
  lineStroke = '2.5px';
  lineStrokeHover = '2.5px';

  circleOpacity = '0.85';
  circleOpacityOnLineHover = '0.25';
  circleRadius = 3;
  circleRadiusHover = 6;

  @Input('ctlBarChart') opt: any;
  @Input('ctlBarData') data: any[];

  tooltip;

  constructor(private el: ElementRef) { }

  ngAfterViewInit(): void {
    this.initChart();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (typeof changes['data'] !== 'undefined') {

        // retrieve the quiz variable change info
        const change = changes['data'];

        // only perform the task if the value has been changed
        if (!change.isFirstChange()) {
            // execute the Http request and retrieve the result
            this.initChart();
        }
    }
  }

  initChart() {
    const self = this;
    if (this.opt && this.opt.width) {
      this.width = this.opt.width;
    }
    if (this.opt && this.opt.height) {
      this.height = this.opt.height;
    }
    if (this.opt && this.opt.margin) {
      this.margin = this.opt.margin;
    }
    if (this.opt && this.opt.duration) {
      this.duration = this.opt.duration;
    }

    if (this.opt && this.opt.lineOpacity) {
      this.lineOpacity = this.opt.lineOpacity;
    }
    if (this.opt && this.opt.lineOpacityHover) {
      this.lineOpacityHover = this.opt.lineOpacityHover;
    }
    if (this.opt && this.opt.otherLinesOpacityHover) {
      this.otherLinesOpacityHover = this.opt.otherLinesOpacityHover;
    }
    if (this.opt && this.opt.lineStroke) {
      this.lineStroke = this.opt.lineStroke;
    }
    if (this.opt && this.opt.lineStrokeHover) {
      this.lineStrokeHover = this.opt.lineStrokeHover;
    }
    if (this.opt && this.opt.circleOpacity) {
      this.circleOpacity = this.opt.circleOpacity;
    }
    if (this.opt && this.opt.circleOpacityOnLineHover) {
      this.circleOpacityOnLineHover = this.opt.circleOpacityOnLineHover;
    }
    if (this.opt && this.opt.circleRadius) {
      this.circleRadius = this.opt.circleRadius;
    }
    if (this.opt && this.opt.circleRadiusHover) {
      this.circleRadiusHover = this.opt.circleRadiusHover;
    }

    let colors = this.colors;
    if (this.opt && this.opt.colors) {
      colors = this.opt.colors;
    }

    var selector = '.barchart';
    if (this.opt && this.opt.selector) {
      selector = this.opt.selector;
    }

    d3.select('#' + selector).select('svg').remove();

    const parseDate = d3.timeParse('%d/%m/%Y');
    const formatDate = d3.timeFormat('%d %B');
    const dataseries: any[] = this.data;

    const keys = d3.keys(dataseries[0]);
    const index = keys.indexOf('date');
    if (index > -1) {
      keys.splice(index, 1);
    }
    //delete keys.date;
    if (dataseries && dataseries.length) {
      dataseries.forEach((d1) => {
        let t = 0;
        for (let i = 0; i < keys.length; ++i) {
          if (keys[i] !== 'date') {
            t += d1[keys[i]];
          }
        }
        d1.total = t;
      });
    }

    const data = [...dataseries];
    // console.log('bar graph data >>> ' + JSON.stringify(data));

    /* Scale */
    const color = d3.scaleOrdinal(d3.schemeCategory10)
      .range(colors);

    data.sort((a, b) => a.date - b.date );

    // set x scale
    const x = d3.scaleTime()
    .rangeRound([0, this.width + this.margin])
    .domain(
      [
        new Date(d3.min(data, (d: any) => new Date(d.date).getTime() - (24 * 3600 * 1000))),
        new Date(d3.max(data, (d: any) => new Date(d.date).getTime() + (24 * 3600 * 1000))),
      ]
    ).nice();

    // set y scale
    const y = d3.scaleLinear()
    .rangeRound([this.height + this.margin, 0])
    .domain([0, d3.max(data, (d: any) =>  d.total )]).nice();

    // set the colors
    const z = d3.scaleOrdinal()
    .range(colors).domain(keys);

    this.tooltip = d3.select('#' + selector)
      .append('div')
      .attr('class', 'tooltip')
      .style('display', 'none');

    const svg = d3.select('#' + selector).append('svg')
    .attr('width', (this.width + 2 * this.margin + 50) + 'px')
    .attr('height', (this.height + 2 * this.margin + 50) + 'px')
    .append('g')
    .attr('transform', `translate(${this.margin}, ${this.margin})`)
    .style('stroke', '#f2f2f2');

    svg.append('g')
      .attr('class', 'grid')
      .attr('transform', 'translate(padding.left, padding.bottom)')
      .style('stroke-dasharray', ('2,2'))
      .style('stroke', '#181818')
      .style('fill', '#000000')
      .call(d3.axisBottom(x)
         .tickSize((this.height + this.margin))
         .tickFormat(null)
      );

    svg.append('g')
      .attr('class', 'grid')
      .attr('transform', 'translate(padding.left, padding.top)')
      .style('opacity', '0.9')
      .style('stroke', '#181818')
      .call(d3.axisLeft(y)
         .tickSize(-(this.width + this.margin))
         .tickFormat(null)
      );


    svg.append('g')
      .selectAll('g')
      .data(d3.stack().keys(keys)(data))
      .enter()
      .append('g')
      .attr('fill', (d, i) =>  colors[i])
      .selectAll('rect')
      .data((d) => d )
      .enter().append('rect')
      .style('opacity', '0.9')
      .style('stroke', '#181818')
      .attr('x', (d, i) => x(data[i].date))
      .attr('y', d => y(d[1]) )
      .attr('height', d => y(d[0]) - y(d[1]) )
      .attr('width', 15/*x.bandwidth()/3*/)
      .on('mouseover', (d) => {
        self.mouseoverD3();
      })
      .on('mousemove', (d) => {
        self.mousemoveD3(d);
      })
      .on('mouseout', (d) => {
        self.mouseoutD3();
      });

    svg.append('g')
      .attr('class', 'axis')
      .style('font-family', 'Ericsson Hilda')
      .style('font-weight', 'normal')
      .attr('transform', `translate(0, ${this.height + this.margin})`)
      .call(
        d3.axisBottom(x)
        .tickFormat(null)
        .ticks(10)
        );

    svg.append('g')
      .attr('class', 'axis')
      .style('font-family', 'Ericsson Hilda')
      .style('font-weight', 'normal')
      .call(d3.axisLeft(y).ticks(10))
      .append('text')
      .attr('x', 2)
      .attr('y', y(y.ticks().pop()) + 0.5)
      .attr('dy', '0.32em')
      .attr('fill', '#000000')
      .attr('text-anchor', 'start');

  }

  private mouseoverD3() {
    this.tooltip
      .style('display', 'inline-block')
      .attr('stroke', '#ffffff')
      .style('position', 'absolute');
  }

  private mousemoveD3(d) {
    this.tooltip
      .html('<div style="background-color: #ffffff; color: #181818;padding: 5px;">' + (d[1] - d[0]) + '</div>')
      .style('left', d3.event.pageX + 10 + 'px')
      .style('top', d3.event.pageY + 10 + 'px');
  }

  private mouseoutD3() {
    this.tooltip
      .style('display', 'none');
  }
}
